import GL from "./global"
import OC from "./oralComment"
import MENU from "./menu"


const t = {}
t.GL = { ...GL }
t.OC = { ...OC }
t.MENU = { ...MENU }
export default t


// WEBPACK FOOTER //
// ./src/i18n/zh-CN/index.js